/* ============================================================
   WORDS — ヘッダー／メニューの挙動（素のJS・外部ライブラリなし）
   対応マークアップ：sections/header.liquid
     1. スクロール80px超でヘッダーを白背景に（トップページのみ）
     2. ティッカーをヒーローの直後へ移動
     3. ハンバーガーメニュー（13b・2ペイン型）の開閉（背面スクロール停止・外側タップ／Escで閉じる）
     4. 左レール（tab）→右ペイン（tabpanel）の切替・最後の選択の復元／言語プルダウン
     5. ヘッダーの検索パネル開閉
     6. PC メガメニュー（9パネル・1024px以上）：ホバー150msで開く／離れて200msで閉じる／Esc・暗幕クリックで閉じる
        パネルは data-mm のキーで引くので、パネルを増やしても JS の変更は不要（news は0記事のとき .wh__link--plain になる）
   ============================================================ */
(function () {
  'use strict';

  var hdr = document.getElementById('hdr');

  /* :has() 非対応ブラウザ向けに帯の有無を body のクラスでも持たせる */
  if (document.querySelector('.wh-bar')) document.body.classList.add('has-shipbar');

  /* --- 0. 固定ヘッダーの実測高さを CSS 変数へ ----------------------
     帯（.wh-bar）は文言が長いと2行に折り返して高さが変わる（375px幅で実測44px）。
     px直書きをやめ、実測した高さを <html> の --wh-bar-h / --wh-h に入れる。
     .wh--bar の top と各ページ先頭ラッパーの padding-top は
     words-tokens.css の --wh-stack（帯＋本体）から計算する。
     帯が無いページでは --wh-bar-h は 0px。
     計測タイミング：即時／DOMContentLoaded／load／フォント読込後／
     ResizeObserver（帯・本体）／orientationchange／pageshow。 ---------- */
  var whBar = document.querySelector('.wh-bar');
  var whRoot = document.documentElement;
  function whMeasure() {
    var bh = whBar ? whBar.getBoundingClientRect().height : 0;
    var hh = hdr ? hdr.getBoundingClientRect().height : 0;
    whRoot.style.setProperty('--wh-bar-h', (Math.round(bh * 100) / 100) + 'px');
    if (hh > 0) whRoot.style.setProperty('--wh-h', (Math.round(hh * 100) / 100) + 'px');
  }
  whMeasure();
  document.addEventListener('DOMContentLoaded', whMeasure);
  window.addEventListener('load', whMeasure);
  window.addEventListener('pageshow', whMeasure);
  window.addEventListener('orientationchange', function () {
    whMeasure();
    window.setTimeout(whMeasure, 150);
  });
  if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
    document.fonts.ready.then(whMeasure);
  }
  if (typeof window.ResizeObserver === 'function') {
    var whRo = new window.ResizeObserver(function () { whMeasure(); });
    if (whBar) whRo.observe(whBar);
    if (hdr) whRo.observe(hdr);
  } else {
    window.addEventListener('resize', whMeasure);
  }

  /* --- 1. スクロールで白背景に切り替え --------------------- */
  if (hdr && hdr.getAttribute('data-home') === '1') {
    var ticking = false;
    var apply = function () {
      hdr.classList.toggle('is-solid', (window.pageYOffset || document.documentElement.scrollTop || 0) > 80);
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(apply);
    }, { passive: true });
    apply();
  }

  /* --- 2. ティッカーをヒーローの直後へ --------------------- */
  var ticker = document.getElementById('wh-ticker');
  if (ticker) {
    var hero = document.querySelector('.hero');
    if (hero && hero.parentNode) {
      hero.parentNode.insertBefore(ticker, hero.nextSibling);
    }
    ticker.classList.add('is-ready');
  }

  /* --- 3. ハンバーガーメニュー（13b・2ペイン型） ----------------
     .mnav（白パネル）を右→左にスライド。開いている間は背面をロック。
     × ／ 外側（.mnav-bg）タップ ／ Esc で閉じる。
     bfcache から戻ってきたときは閉じた状態に戻す。 --------------- */
  var menu = document.getElementById('wh-menu');
  var menuBg = document.getElementById('wh-menu-bg');
  var burger = document.getElementById('wh-burger');
  var closeBtn = document.getElementById('wh-menu-close');
  var scrollY = 0;

  function openMenu() {
    if (!menu) return;
    scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (menuBg) {
      menuBg.hidden = false;
      /* hidden 解除の直後にクラスを付けてフェードさせる */
      window.requestAnimationFrame(function () { menuBg.classList.add('is-open'); });
    }
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('wh-lock');
    document.body.classList.add('wh-lock');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    if (closeBtn) closeBtn.focus();
  }

  function closeMenu() {
    if (!menu) return;
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    if (menuBg) {
      menuBg.classList.remove('is-open');
      window.setTimeout(function () { if (!menu.classList.contains('is-open')) menuBg.hidden = true; }, 260);
    }
    document.documentElement.classList.remove('wh-lock');
    document.body.classList.remove('wh-lock');
    if (burger) {
      burger.setAttribute('aria-expanded', 'false');
      burger.focus();
    }
    window.scrollTo(0, scrollY);
  }

  if (burger) burger.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (menuBg) menuBg.addEventListener('click', closeMenu);
  /* パネル自身（子要素以外）をタップした場合も閉じる */
  if (menu) {
    menu.addEventListener('click', function (e) { if (e.target === menu) closeMenu(); });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.keyCode !== 27) return;
    if (menu && menu.classList.contains('is-open')) closeMenu();
    var sp = document.getElementById('wh-search');
    if (sp && sp.classList.contains('is-open')) toggleSearch(false);
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted && menu && menu.classList.contains('is-open')) closeMenu();
  });

  /* --- 4. 左レール（tab）→ 右ペイン（tabpanel）の切替 ----------
     タップで aria-selected と hidden を切替（ページ遷移なし・フェードなし）。
     切替時は右ペインのスクロールを先頭へ。最後の選択は localStorage に保存し、
     次回開いたときに復元する。初期値はキャップ（menu_groups の先頭）。 --- */
  var PANE_KEY = 'words_mnav_pane';
  var tabs = menu ? menu.querySelectorAll('.mnav__rail [data-pane]') : [];
  var panes = menu ? menu.querySelectorAll('.mnav__pane[data-pane]') : [];

  function findPane(key) {
    for (var i = 0; i < panes.length; i++) {
      if (panes[i].getAttribute('data-pane') === key) return panes[i];
    }
    return null;
  }

  function selectPane(key, save) {
    var target = findPane(key);
    if (!target) return false;
    for (var i = 0; i < panes.length; i++) {
      var on = panes[i] === target;
      panes[i].hidden = !on;
      if (on) panes[i].scrollTop = 0;
    }
    for (var j = 0; j < tabs.length; j++) {
      var sel = tabs[j].getAttribute('data-pane') === key;
      tabs[j].setAttribute('aria-selected', sel ? 'true' : 'false');
      tabs[j].setAttribute('tabindex', sel ? '0' : '-1');
    }
    if (save) {
      try { window.localStorage.setItem(PANE_KEY, key); } catch (err) { /* 保存できなくても動作に影響なし */ }
    }
    return true;
  }

  if (menu && tabs.length && panes.length) {
    for (var t = 0; t < tabs.length; t++) {
      tabs[t].addEventListener('click', function () {
        selectPane(this.getAttribute('data-pane'), true);
      });
    }
    /* 矢印キーでレール内を移動（tablist の基本操作） */
    menu.querySelector('.mnav__rail').addEventListener('keydown', function (e) {
      var k = e.key;
      if (k !== 'ArrowDown' && k !== 'ArrowUp') return;
      var cur = -1;
      for (var i = 0; i < tabs.length; i++) { if (tabs[i] === document.activeElement) cur = i; }
      if (cur < 0) return;
      e.preventDefault();
      var next = k === 'ArrowDown' ? (cur + 1) % tabs.length : (cur - 1 + tabs.length) % tabs.length;
      tabs[next].focus();
      selectPane(tabs[next].getAttribute('data-pane'), true);
    });

    var initial = null;
    try { initial = window.localStorage.getItem(PANE_KEY); } catch (err) { initial = null; }
    if (!initial || !selectPane(initial, false)) {
      if (!selectPane('cap', false)) {
        /* cap が無い場合は Liquid 側で選択済みのタブ、それも無ければ先頭 */
        var pre = menu.querySelector('.mnav__rail [aria-selected="true"]') || tabs[0];
        selectPane(pre.getAttribute('data-pane'), false);
      }
    }
  }

  /* 言語の切替：フッター上にリストを出す。開閉だけを持つ。
     切替そのものは Shopify標準の localization フォーム（sections/header.liquid）が送信する。
     公開中の言語が1つだけのときは要素自体が出ないので、下のガードで何もしない。 */
  var langBtn = document.getElementById('mnav-langbtn');
  var langList = document.getElementById('mnav-langlist');
  if (langBtn && langList) {
    langBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = langList.hidden;
      langList.hidden = !open;
      langBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) {
      if (langList.hidden) return;
      if (langList.contains(e.target)) return;
      langList.hidden = true;
      langBtn.setAttribute('aria-expanded', 'false');
    });
  }

  /* --- 5. 検索パネル --------------------------------------- */
  var sBtn = document.getElementById('wh-search-btn');
  var sPanel = document.getElementById('wh-search');

  function toggleSearch(force) {
    if (!sPanel) return;
    var open = (typeof force === 'boolean') ? force : !sPanel.classList.contains('is-open');
    sPanel.classList.toggle('is-open', open);
    if (sBtn) sBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var inp = sPanel.querySelector('input[name="q"]');
      if (inp) setTimeout(function () { inp.focus(); }, 40);
    }
  }

  if (sBtn && sPanel) {
    sBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      toggleSearch();
    });
    sPanel.addEventListener('click', function (e) { e.stopPropagation(); });
    document.addEventListener('click', function () { toggleSearch(false); });
  }
  /* --- 6. PC メガメニュー（9パネル） ---------------------------
     ナビ項目（.wh-nd--mm[data-mm]）にマウスが乗って 150ms で該当パネルを表示、
     ナビ・パネルから離れて 200ms で閉じる。パネルの切替は即時（フェードなし）。
     フォーカス（Tab）でも開く。Esc／暗幕クリック／ヘッダー外へのフォーカス移動で閉じる。
     1023px以下（SPドロワー）では何もしない。 -------------------- */
  var mm = document.getElementById('wh-mm');
  var mmBg = document.getElementById('wh-mm-bg');
  if (hdr && mm) {
    var mmItems = hdr.querySelectorAll('.wh-nd--mm[data-mm]');
    var mmPanels = mm.querySelectorAll('.wh-mm__panel[data-mm]');
    var mmMq = window.matchMedia('(min-width:1024px)');
    var mmOpenT = null;
    var mmCloseT = null;
    var mmCur = null;
    var mmHover = false;
    hdr.classList.add('wh--mm');

    function mmFind(list, key) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].getAttribute('data-mm') === key) return list[i];
      }
      return null;
    }
    function mmClearTimers() {
      if (mmOpenT) { window.clearTimeout(mmOpenT); mmOpenT = null; }
      if (mmCloseT) { window.clearTimeout(mmCloseT); mmCloseT = null; }
    }
    function mmOpen(key) {
      mmClearTimers();
      if (!mmMq.matches) return;
      var panel = mmFind(mmPanels, key);
      if (!panel) return;
      if (mmCur === key) return;
      for (var i = 0; i < mmPanels.length; i++) mmPanels[i].hidden = mmPanels[i] !== panel;
      for (var j = 0; j < mmItems.length; j++) {
        var on = mmItems[j].getAttribute('data-mm') === key;
        var link = mmItems[j].querySelector('.wh__link');
        if (!link) continue;
        link.classList.toggle('is-open', on);
        link.setAttribute('aria-expanded', on ? 'true' : 'false');
      }
      mm.hidden = false;
      if (mmBg) mmBg.hidden = false;
      hdr.classList.add('is-mm-open');
      mmCur = key;
      toggleSearch(false);
    }
    function mmClose(returnFocus) {
      mmClearTimers();
      if (mmCur === null) return;
      var key = mmCur;
      mmCur = null;
      for (var i = 0; i < mmPanels.length; i++) mmPanels[i].hidden = true;
      for (var j = 0; j < mmItems.length; j++) {
        var link = mmItems[j].querySelector('.wh__link');
        if (!link) continue;
        link.classList.remove('is-open');
        link.setAttribute('aria-expanded', 'false');
      }
      mm.hidden = true;
      if (mmBg) mmBg.hidden = true;
      hdr.classList.remove('is-mm-open');
      if (returnFocus) {
        var item = mmFind(mmItems, key);
        var l = item ? item.querySelector('.wh__link') : null;
        if (l) l.focus();
      }
    }
    function mmScheduleOpen(key) {
      mmClearTimers();
      mmOpenT = window.setTimeout(function () { mmOpen(key); }, 150);
    }
    function mmScheduleClose() {
      mmClearTimers();
      mmCloseT = window.setTimeout(function () { mmClose(false); }, 200);
    }

    for (var m = 0; m < mmItems.length; m++) {
      (function (item) {
        var key = item.getAttribute('data-mm');
        item.addEventListener('mouseenter', function () { mmHover = true; mmScheduleOpen(key); });
        item.addEventListener('mouseleave', function () { mmHover = false; mmScheduleClose(); });
        /* Tab でフォーカスしたときは待たずに開く */
        item.addEventListener('focusin', function () { mmOpen(key); });
      })(mmItems[m]);
    }
    mm.addEventListener('mouseenter', function () { mmHover = true; mmClearTimers(); });
    mm.addEventListener('mouseleave', function () { mmHover = false; mmScheduleClose(); });
    /* パネルを持たないただのリンク（似合う帽子診断／お知らせ）に乗ったら、開いているパネルはすぐ閉じる */
    var mmPlain = hdr.querySelectorAll('.wh__nav .wh__link--plain');
    for (var q = 0; q < mmPlain.length; q++) {
      mmPlain[q].addEventListener('mouseenter', function () { mmHover = false; mmClose(false); });
      mmPlain[q].addEventListener('focusin', function () { mmHover = false; mmClose(false); });
    }
    if (mmBg) mmBg.addEventListener('click', function () { mmClose(false); });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.keyCode !== 27) return;
      if (mmCur !== null) mmClose(true);
    });
    /* フォーカスがヘッダーの外へ出たら閉じる（Tab で通り抜けたとき） */
    hdr.addEventListener('focusout', function (e) {
      var to = e.relatedTarget;
      if (to && hdr.contains(to)) return;
      if (mmHover) return;
      if (mmCur !== null) mmScheduleClose();
    });
    /* パネルの外（本文）をクリックしたら閉じる */
    document.addEventListener('click', function (e) {
      if (mmCur === null) return;
      if (hdr.contains(e.target)) return;
      mmClose(false);
    });
    var mmOnMq = function () { if (!mmMq.matches) mmClose(false); };
    if (mmMq.addEventListener) mmMq.addEventListener('change', mmOnMq);
    else if (mmMq.addListener) mmMq.addListener(mmOnMq);
    window.addEventListener('pageshow', function () { mmClose(false); });
  }
})();
